export const CommodityActionTypes = {
    COMMODITY_DATA_FIRST: '@@auth/COMMODITY_DATA_FIRST',
    COMMODITY_DATA_LOADING: '@@auth/COMMODITY_DATA_LOADING',
    COMMODITY_DATA_SUCCESS: '@@auth/COMMODITY_DATA_SUCCESS',
    COMMODITY_DATA_ERROR: '@@auth/COMMODITY_DATA_ERROR',
    COMMODITY_DATA_RESET: '@@auth/COMMODITY_DATA_RESET',

    CREATE_COMMODITY_DATA_FIRST: '@@auth/CREATE_COMMODITY_DATA_FIRST',
    CREATE_COMMODITY_DATA_LOADING: '@@auth/CREATE_COMMODITY_DATA_LOADING',
    CREATE_COMMODITY_DATA_SUCCESS: '@@auth/CREATE_COMMODITY_DATA_SUCCESS',
    CREATE_COMMODITY_DATA_ERROR: '@@auth/CREATE_COMMODITY_DATA_ERROR',
    CREATE_COMMODITY_DATA_RESET: '@@auth/CREATE_COMMODITY_DATA_RESET',

    UPDATE_COMMODITY_DATA_FIRST: '@@auth/UPDATE_COMMODITY_DATA_FIRST',
    UPDATE_COMMODITY_DATA_LOADING: '@@auth/UPDATE_COMMODITY_DATA_LOADING',
    UPDATE_COMMODITY_DATA_SUCCESS: '@@auth/UPDATE_COMMODITY_DATA_SUCCESS',
    UPDATE_COMMODITY_DATA_RESET: '@@auth/UPDATE_COMMODITY_DATA_RESET',
    UPDATE_COMMODITY_DATA_ERROR: '@@auth/UPDATE_COMMODITY_DATA_ERROR',

    DELETE_COMMODITY_DATA_FIRST: '@@auth/DELETE_COMMODITY_DATA_FIRST',
    DELETE_COMMODITY_DATA_LOADING: '@@auth/DELETE_COMMODITY_DATA_LOADING',
    DELETE_COMMODITY_DATA_SUCCESS: '@@auth/DELETE_COMMODITY_DATA_SUCCESS',
    DELETE_COMMODITY_DATA_RESET: '@@auth/DELETE_COMMODITY_DATA_RESET',
    DELETE_COMMODITY_DATA_ERROR: '@@auth/DELETE_COMMODITY_DATA_ERROR',

    UPLOAD_COMMODITY_DATA_FIRST: '@@auth/UPLOAD_COMMODITY_DATA_FIRST',
    UPLOAD_COMMODITY_DATA_LOADING: '@@auth/UPLOAD_COMMODITY_DATA_LOADING',
    UPLOAD_COMMODITY_DATA_SUCCESS: '@@auth/UPLOAD_COMMODITY_DATA_SUCCESS',
    UPLOAD_COMMODITY_DATA_RESET: '@@auth/UPLOAD_COMMODITY_DATA_RESET',
    UPLOAD_COMMODITY_DATA_ERROR: '@@auth/UPLOAD_COMMODITY_DATA_ERROR',

    STATE_EMPTY_FIRST: '@@auth/STATE_EMPTY_FIRST',
};
